import { newId } from '@/utils.js'
import { db, Timestamp } from '@/firebase.js'
import { firestoreAction } from 'vuexfire'

const getDefaultState = () => {
  return {
    data: [],
    ref: ''
  }
}

const state = getDefaultState()

const getters = {
  data(state) {
    return { ...state.data }
  },
  ref(state) {
    return state.ref
  },
  tasks(state) {
    return Object.assign({}, ...state.data.map(i => ({ [i.id]: i })))
  },
  taskById(state, getters) {
    return id => {
      try {
        return getters['tasks'][id]
      } catch {
        return null
      }
    }
  }
}

const actions = {
  bindStore: firestoreAction(
    ({ bindFirestoreRef, commit, state }, { storeId }) => {
      commit(
        'setRef',
        db
          .collection('stores')
          .doc(storeId)
          .collection('tasks')
      )
      return bindFirestoreRef('data', state.ref)
    }
  ),
  unbindStore: firestoreAction(({ unbindFirestoreRef }) => {
    unbindFirestoreRef('data')
  }),
  create: async function({ getters }, payload) {
    let id = newId()
    let data = {
      ...payload,
      createdAt: Timestamp.now(),
      id: id
    }
    console.log('tasks/create', id, data)
    return getters.ref
      .doc(id)
      .set(data, { merge: true })
      .then(() => id)
      .catch(err => err)
  },
  delete: async function({ dispatch }, id) {
    console.log('tasks/delete', id)
    return dispatch('updateItem', { id, data: { status: 'deleted' } })
  },
  updateItem({ getters, rootGetters }, { id, data }) {
    console.log('tasks/updateItem', id, data)
    return getters.ref.doc(id).update({
      ...data,
      updatedAt: Timestamp.now(),
      updatedBy: rootGetters['user/id']
    })
  },
  resetStoreState({ commit }) {
    commit('resetState', null)
  }
}

const mutations = {
  setRef(state, ref) {
    state.ref = ref
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  }
}

const tasks = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default tasks
